<template>
  <div class="CExhibition" @click="dblBtn">
    <div class="search">
      <el-input placeholder="产品名称/规格" v-model="keyword" class="input-with-select" @keyup.enter.native="getWareList">
        <el-button slot="append" icon="el-icon-search" @click="getWareList"></el-button>
      </el-input>
    </div>
    <div class="listCont">
      <el-table :data="wareList" height="7.5rem" style="width:100%;" cell-class-name="ellipsis">
        <el-table-column type="index" label="序号" width="120"></el-table-column>
        <el-table-column prop="product_name" label="产品名称"></el-table-column>
        <el-table-column prop="spec" label="规格"></el-table-column>
        <el-table-column prop="supplier" label="供应商"></el-table-column>
        <el-table-column prop="number" label="库存" width="130"></el-table-column>
        <el-table-column prop="storage" label="科室"></el-table-column>
        <el-table-column prop="storageName" label="仓位" width="250"></el-table-column>
      </el-table>
    </div>
    <el-button class="backUp" @click="backUp" v-show="showBtn == true">修改配置</el-button>
    <currtime :isShowInfo="false"></currtime>
  </div>
</template>

<script>
import currtime from '../../assets/currTime'
import { adminApi, wareApi } from "../../../static/js/api.js"
import { checkData } from '../../../static/js/utils/util.js'
import * as config from '../../../static/js/config.js';
import { showLoading,hideLoading } from '../../../static/js/utils/utility.js'
export default {
  name: 'CExhibition',
  data () {
    return {
      wareId:[],

      keyword:'',

      wareList:[],
      
      showBtn:false,
      num:0,//点击次数
    }
  },
  //定义这个sweiper对象  
  computed: {
    
  },
  mounted(){
    
  },
  components:{
    currtime,
  },
  created(){
    var configStorage = JSON.parse(localStorage.getItem('configStorage'))
    if(configStorage){
      var wareId=[]
      for(var i in configStorage.wareList){
        wareId.push(configStorage.wareList[i].id)
      }
      this.wareId = wareId
    }
    this.getWareList();
  },
  methods:{
    //获取库存列表
    async getWareList(){
      var that = this
      // showLoading();
      var data = {
        'device_no_id':that.wareId,
        'name':that.keyword,
      }
      var res = await wareApi.showProduct(data)
      if (res.meta.code == 200) {
        // const arr = []
        // for(let i in res.body){
        //   for(let ii in res.body[i].data){
        //     res.body[i].data[ii].locationName = res.body[i].data[ii].name+res.body[i].data[ii].location
        //     arr.push(res.body[i].data[ii])
        //   }
        // }
        for(let i in res.body){
          res.body[i].storageName = res.body[i].storage+res.body[i].location_id
        }
        that.wareList = res.body
      } else {
        that.$message.error(res.meta.message)
      }
    },
    
    //返回
    backUp(){
      this.$router.push({
        path:'/CConfigSetting',
        query:{
          'project':true,
        }
      })
    },
    //连续点击屏幕5次
    dblBtn(){
      var that = this;
      this.num++
      if(this.num==1){
        that.timer1=new Date().getTime()/1000
      }
      if(this.num==5){
        this.timer4= new Date().getTime()/1000
        if(that.timer4-that.timer1<=2){
          that.num=0
          that.showBtn=true
          setTimeout(function(){
            that.showBtn = false
          },5000);
        }else {
          this.num=0
        }
      }
    },
  },
  watch :{

  },
}
</script>

<style lang="less">
.CExhibition{
  height: 100vh;
  padding-top: 0.3rem;
  box-sizing: border-box;
  .ellipsis>div{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .el-table{
    font-size: 0.3rem;
    background: none;
    &::before{
      height: 0;
    }
    th, tr{
      background: none;
    }
    tr:hover>td{
      background: none;
    }
  }
  .el-table td, .el-table th{
    color: #fff;
    padding: 0.2rem 0;
    font-size: 0.3rem;
    border-bottom: 0.02rem solid #ebeef5;
  }
  .el-table .cell{
    line-height: 0.32rem;
  }
  .search{
    width: 48.5%;
    margin: 0 auto 0.3rem;
    .el-input-group{
      font-size: 0.3rem;
      display: flex;
      align-items: center;
      .el-input__inner{
        display: inline-flex;
        height: 0.85rem;
        line-height: 0.85rem;
        background: #fff;
        color: #666;
        border: none;
        border-radius: 0;
        border-top-left-radius: 0.1rem;
        border-bottom-left-radius: 0.1rem;
        padding: 0 0.3rem;
        box-sizing: border-box;
      }
      .el-input-group__append, .el-input-group__prepend{
        width: auto;
        display: inline-flex;
        background: #fff;
        color: #525252;
        height: 0.85rem;
        border: none;
        border-radius: 0;
        font-size: 0.4rem;
        border-top-right-radius: 0.1rem;
        border-bottom-right-radius: 0.1rem;
      }
    }
  }
  .backUp{
    position: absolute;
    right: 0.94rem;
    bottom: 0.47rem;
    height: 0.94rem;
    width: 2.54rem;
    padding: 0;
    font-size: 0.4rem;
    color: #fff;
    font-weight: bold;
    border: none;
    border-radius: 0.12rem;
    line-height:0.94rem;
    background: linear-gradient(#4aaafe, #0769be);
  }
  .currTime{
    position: absolute;
    right: 0.2rem;
    top: 0.4rem;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/CUnmanned/CExhibition.vue